<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Product Batch Numbers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Product Batch Numbers",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Product Batch Numbers",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "batch",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "days_field",
          sortable: true,
          label: "DAYS TO EXPIRE",
        },
        {
          key: "expiry",
          sortable: true,
          label: "EXPIRY DATE",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "batch",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "days_field",
          sortable: true,
          label: "DAYS TO EXPIRE",
        },
        {
          key: "expiry",
          sortable: true,
          label: "EXPIRY DATE",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
      ],

      filterBatches:{
        category:'',
        product:''
      }
    };
  },
  computed: {
    ...mapGetters("stock", ["Batches","FilterStatus"]),
    ...mapGetters("auth", ["branchid","Branches"]),
    ...mapGetters("products", ["Categories"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Batches ? this.Batches.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Batches ? this.Batches.length : 1;
  },

  methods: {
    ...mapActions({
      FetchBatches: "stock/fetchBatches",
      FetchCategories: "products/fetchPCategories",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    FilterBatches(){
      this.FetchBatches(this.filterBatches);
    }
  },
  created() {
    this.FetchBatches(this.filterBatches);
    this.FetchCategories();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8">
                <h5 class="text-warning">Product batch numbers</h5>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-md-4 form-group mb-2">
                <label>SEARCH BY CATEGORY</label>
                
                <model-list-select
                  :list="Categories ? Categories : []"
                  v-model="filterBatches.category"
                  option-value="id"
                  option-text="catName"
                  placeholder="Select Category"
                  @input="FilterBatches()"
                >
                </model-list-select>
              </div>
              <div class="col-md-4 form-group">
                Search Product
                <div class="input-group">
                <input
                  v-model="filterBatches.product"
                  type="text"
                  class="form-control"
                  @keyup.enter="FilterBatches()"
                /> 
                <div class="input-group-append">
                  <button class="btn btn-primary" type="button" @click="FilterBatches()">
                    
                    <b-spinner
                      v-if="FilterStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>

                  <span>Search</span>
                  
                  </button>
                </div>
                
              </div>              
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Batches ? Batches : []"
                :fields="branchid==0?fields1:fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(days_field)="data"> {{ data.item.days }} days </template>
              </b-table>
            </div>
            <center>
                <Loader v-if="!Batches" />
              </center>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
